import React from "react";
import { useDispatch } from "react-redux";

import SavingsCalculatorForm from "./SavingsPotCalculatorForm";
import { ThemeContext } from "../../context/ThemeContext";
import "./SavingsPotCalculator.scss";
import { submitForm } from "@om/redux/actions/savingsPotCalculator/savingsPotCalculatorForm";

const SavingsPotCalculator = ({
  twoColumnImageLeftContent,
  tableContent,
  isInContainer,
  slot,
  onCompleteEvent,
}) => {
  const dispatch = useDispatch();
  const theme = React.useContext(ThemeContext);
  const handleSubmit = (formData) => {
    dispatch(submitForm(formData));
    onCompleteEvent && onCompleteEvent();
  };

  return (
    <div
      className={`${theme} savings-pot-calculator-container ${
        isInContainer ? "container-full-width" : ""
      } `}
      slot={slot}
      id="savings-pot-calculator"
    >
      <SavingsCalculatorForm
        twoColumnImageLeftContent={twoColumnImageLeftContent}
        tableContent={tableContent}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default SavingsPotCalculator;
